export default {
  zoomIn: ({ commit }, payload) => {
    commit('SET_DIALOG_IMAGE', payload.replace(/\/small\/|\/medium\//g, '/large/'))
    commit('SET_DIALOG', true)
  },

  setDialog: ({ commit }, payload) => {
    commit('SET_DIALOG', payload)
  }
}